import { registerLocaleData } from '@angular/common';
import localeSlovenian from '@angular/common/locales/sl';
import { enableProdMode } from '@angular/core';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

import moment from 'moment';
import 'moment/locale/sl.js';

import { bootstrapApplication } from '@angular/platform-browser';
import { CONTRACTOR_TIMEZONE } from './app/_shared/constants/date-constants.const';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

moment.locale('sl');

dayjs.extend(updateLocale);
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.tz.setDefault(CONTRACTOR_TIMEZONE);
import(`dayjs/locale/sl.js`).then(() => {
    dayjs.locale('sl');
    dayjs.updateLocale('sl', {
        weekStart: 1,
    });

    registerLocaleData(localeSlovenian, 'sl');
});

bootstrapApplication(AppComponent, appConfig);
